var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilesIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.999,
    height: 11.999,
    viewBox: "0 0 16.999 11.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    "data-name": "Group 2161",
    transform: "translate(276.412 -534.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M-274.094,537.756a1.72,1.72,0,0,1,.873-.243h11.737v-.467a.677.677,0,0,0-.677-.677h-8.2c-.231-1-.526-1.658-1.3-1.61h-3.705c-.982,0-1.049,1.524-1.049,1.524v8.047l1.707-5.848A1.353,1.353,0,0,1-274.094,537.756Zm11.866-.9h.006v0h-.006Zm-5.688,0h.007v0h-.007Zm-4.6-.733h.007v0h-.007Zm-3.454,5.4h-.007v0h.007Zm.839-5.4h-.007v0h.007Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M-259.946,538.19h-13.275a.9.9,0,0,0-.84.5l-2.266,7.563c-.09.278.14.5.514.5h13.575a.9.9,0,0,0,.84-.5l1.965-7.563C-259.342,538.414-259.573,538.19-259.946,538.19Zm-15.187,7.587h-.006v0h.006Zm2.629-6.765h-.007v0h.007Zm.888,6.762h-.006v0h.006Zm8.968,0h-.007v0h.007Zm2.1-6.345h-.007v0h.007Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIco);
export default __webpack_public_path__ + "static/media/filesIco.756c32ce.svg";
export { ForwardRef as ReactComponent };